var _defs, _g, _path, _path2, _g2, _path3, _path4, _g3, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _g4, _g5, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMalfunctionsPeltonHorizontal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 918 612",
    width: 918,
    height: 612,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n      .malfunction {\n        cursor: pointer;\n      }\n\n      .group {\n        cursor: pointer;\n      }\n\n      .st0, .st1, .st2, .st3, .st4, .st5, .st6, .st7, .st8, .st9, .st10, .st11, .st12, .st13, .st14, .st15 {\n        stroke-width: 1.3px;\n      }\n\n      .st0, .st1, .st2, .st3, .st4, .st5, .st16, .st7, .st8, .st11, .st12, .st17, .st18, .st19, .st20, .st14, .st21, .st15 {\n        stroke: #202020;\n      }\n\n      .st0, .st1, .st3, .st4, .st5 {\n        stroke-linecap: round;\n      }\n\n      .st0, .st1, .st3, .st5 {\n        stroke-linejoin: round;\n      }\n\n      .st0, .st22, .st7 {\n        fill: #ddd;\n      }\n\n      .st1, .st2, .st3, .st4, .st5, .st6, .st9, .st10, .st13, .st19, .st20, .st14 {\n        fill: none;\n      }\n\n      .st2 {\n        stroke-dasharray: 1.8 1.8 1.8 1.8 1.8 1.8;\n      }\n\n      .st2, .st4, .st6, .st16, .st7, .st8, .st9, .st10, .st11, .st12, .st17, .st18, .st13, .st19, .st20, .st14, .st21, .st15 {\n        stroke-miterlimit: 2.1;\n      }\n\n      .st3 {\n        stroke-dasharray: 0 3.6;\n      }\n\n      .st5 {\n        stroke-dasharray: 0 5.2;\n      }\n\n      .st6 {\n        stroke: #6f6f6f;\n      }\n\n      .st16, .st8 {\n        fill: #9c9c9c;\n      }\n\n      .st16, .st17, .st20, .st21 {\n        stroke-width: 1.2px;\n      }\n\n      .st9 {\n        stroke: #ddd;\n      }\n\n      .st10 {\n        stroke: #ededed;\n      }\n\n      .st11 {\n        fill: #6f6f6f;\n      }\n\n      .st12, .st17 {\n        fill: #fff;\n      }\n\n      .st18 {\n        fill: #f6f6f6;\n        stroke-width: .9px;\n      }\n\n      .st13 {\n        stroke: #9c9c9c;\n      }\n\n      .st19 {\n        stroke-width: 1.2px;\n      }\n\n      .st21, .st15 {\n        fill: #ededed;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M683.5,293.8h37.8c.6,0,1.1-.3,1.5-.7s.6-1,.6-1.6v-.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M791.8,233.5h-66.3c-.6,0-1.1.3-1.5.7s-.6,1-.6,1.6v55.4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M683.1,251.1v71.7c0,.6-.2,1.1-.6,1.5s-.9.6-1.5.6h-131.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M788.7,228.9c.6,0,1.1.3,1.5.7.4.4.6,1,.6,1.6v34.5c0,.6-.2,1.2-.6,1.6s-.9.7-1.5.7h-37.8c-.6,0-1.1.3-1.5.7s-.6,1-.6,1.6v.5c0,.6.2,1.2.6,1.6s.9.7,1.5.7h6.4c.6,0,1.1.3,1.5.7s.6,1,.6,1.6c0,.6-.2,1.2-.6,1.6s-.9.7-1.5.7h-6.4c-.6,0-1.1.3-1.5.7s-.6,1-.6,1.6v2.8c0,.6.2,1.2.6,1.6s.9.7,1.5.7h15.5c.6,0,1.1.3,1.5.7s.6,1,.6,1.6v25.1c0,.6-.2,1.2-.6,1.6s-.9.7-1.5.7h-169.3c-1.6,0-2.8,1.3-2.9,2.8l-.4,39.9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M609.1,275.4h22.3c.6,0,1.1.2,1.5.6s.6.9.6,1.5v170.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M583.5,284.4h22.3c.6,0,1.1.2,1.5.6s.6.9.6,1.5v170.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M609.2,275.4h-231.5c-.6,0-1.1-.2-1.5-.6s-.6-.9-.6-1.5h0v-26.1c0-.6.2-1.1.6-1.5s.9-.6,1.5-.6h114c.6,0,1.1-.2,1.5-.6s.6-.9.6-1.5v-8.3c0-.6-.2-1.1-.6-1.5s-.9-.6-1.5-.6h-147.1c-.6,0-1.1-.2-1.5-.6s-.6-.9-.6-1.5v-6.6c0-.6.2-1.1.6-1.5s.9-.6,1.5-.6h58c.6,0,1.1-.2,1.5-.6s.6-.9.6-1.5h0v-33.5c0-.6-.2-1.1-.6-1.5s-.9-.6-1.5-.6h-39.3c-.6,0-1.1-.2-1.5-.6s-.6-.9-.6-1.5h0v-30.9c0-.6-.2-1.1-.6-1.5s-.9-.6-1.5-.6h-24.6c-.3,0-.6,0-.8-.1s-.5-.3-.7-.5-.4-.4-.5-.7c-.1-.3-.2-.5-.1-.8h0v-19c0-.3,0-.6.1-.8s.3-.5.5-.7.4-.4.7-.5.5-.2.8-.1h41.6c.6,0,1.1-.2,1.5-.6s.6-.9.6-1.5v-4c0-.6.2-1.1.6-1.5s.9-.6,1.5-.6h36.8c.6,0,1.1.2,1.5.6s.6.9.6,1.5h0v2.2c0,.6-.2,1.1-.6,1.5s-.9.6-1.5.6h-5.1c-.3,0-.6,0-.8.1s-.5.3-.7.5-.4.4-.5.7c-.1.3-.2.5-.1.8h0v1.7c0,.6.2,1.1.6,1.5s.9.6,1.5.6h5.1c.6,0,1.1.2,1.5.6s.6.9.6,1.5v2.2c0,.6-.2,1.1-.6,1.5s-.9.6-1.5.6h-30.4c-.3,0-.6,0-.8.1s-.5.3-.7.5-.4.4-.5.7c-.1.3-.2.5-.1.8h0v8.4c0,.3,0,.6.1.8s.3.5.5.7.4.4.7.5c.3.1.5.2.8.1h115.6c.3,0,.6,0,.8-.1s.5-.3.7-.5.4-.4.5-.7c.1-.3.2-.5.1-.8h0v-14.8c0-.6.2-1.1.6-1.5s.9-.6,1.5-.6h.7c.6,0,1.1.2,1.5.6s.6.9.6,1.5v20.4c0,.6-.2,1.1-.6,1.5s-.9.6-1.5.6h-45.1c-.6,0-1.1.2-1.5.6s-.6.9-.6,1.5v125.9c0,.6.2,1.1.6,1.5s.9.6,1.5.6h141.6"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M204.3,28.9c33.3,55.4,71.3,46.9,77.1,47.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M197,51.8c20,33,51.9,33.9,61.9,31.8"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M731.3,167.7h-413.1c-.7,0-1.3-.3-1.7-.7-.5-.5-.7-1.1-.7-1.7v-66.2c0-.6-.2-1.2-.6-1.6-.4-.5-.9-.8-1.5-.8-6.2-1-24.4-4.9-32.2-20.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M731.1,167.7c.7,0,1.3.3,1.7.7.5.5.7,1.1.7,1.7v186.8"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M301.7,160.6h-65.2v3.4h65.2v-3.4h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M304,164h-70.1v14.4h70.1v-14.4Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M287.8,160.7c2.3,0,4.2-1.9,4.2-4.2s-1.9-4.2-4.2-4.2-4.2,1.9-4.2,4.2,1.9,4.2,4.2,4.2Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M277.1,160.7c2.3,0,4.2-1.9,4.2-4.2s-1.9-4.2-4.2-4.2-4.2,1.9-4.2,4.2,1.9,4.2,4.2,4.2Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M261.2,160.7c2.3,0,4.2-1.9,4.2-4.2s-1.9-4.2-4.2-4.2-4.2,1.9-4.2,4.2,1.9,4.2,4.2,4.2Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M250.5,160.7c2.3,0,4.2-1.9,4.2-4.2s-1.9-4.2-4.2-4.2-4.2,1.9-4.2,4.2,1.9,4.2,4.2,4.2Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M287.6,100.8h-37.3v51.6h37.3v-51.6h0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M297.3,144.7h-9.5v3.6h9.5v-3.6Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M287.6,141.8h9.7v-25.4l-9.7-15v40.5h0Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M250.4,144.7h-9.5v3.6h9.5v-3.6Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M250.4,141.8h-9.5v-25.4l9.5-15v40.5h0Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M287.6,97h-37.3v3.8h37.3v-3.8Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M281.6,75.7h-1.6v21.4h1.6v-21.4h0Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M280.8,90.9c.7,0,1.4-.3,1.9-.8.5-.5.8-1.2.8-1.9v-8.1c0-.7-.3-1.4-.8-1.9s-1.2-.8-1.9-.8-1.4.3-1.9.8c-.5.5-.8,1.2-.8,1.9v8.1c0,.7.3,1.4.8,1.9s1.2.8,1.9.8h0Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M258.1,83.1h-1.6v13.6h1.6v-13.6Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M257.3,93.5c.7,0,1.4-.3,1.9-.8.5-.5.8-1.2.8-1.9v-3.3c0-.7-.3-1.4-.8-1.9-.5-.5-1.2-.8-1.9-.8s-1.4.3-1.9.8c-.5.5-.8,1.2-.8,1.9v3.3c0,.7.3,1.4.8,1.9.5.5,1.2.8,1.9.8Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M414.3,142.4c8.7,0,15.8-7.1,15.8-15.8s-7.1-15.8-15.8-15.8-15.8,7.1-15.8,15.8,7.1,15.8,15.8,15.8Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M809.1,216.1h-19.7v69.8h19.7v-69.8h0Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M828.9,216.1h-19.7v69.8h19.7v-69.8h0Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M813.3,228h11.4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M813.3,231.8h11.4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M813.3,235.7h11.4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M813.3,239.5h11.4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M809.2,251h19.8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M848.7,216.1h-19.7v69.8h19.7v-69.8h0Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M833.1,228h11.4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M833.1,231.8h11.4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M833.1,235.7h11.4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M833.1,239.5h11.4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M829,251h19.7"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M868.4,216.1h-19.7v69.8h19.7v-69.8h0Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M852.8,228h11.4"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M852.8,231.8h11.4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M852.8,235.7h11.4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M852.8,239.5h11.4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M848.7,251h19.8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M888.1,216.1h-19.7v69.8h19.7v-69.8h0Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M872.6,228h11.4"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M872.6,231.8h11.4"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M872.6,235.7h11.4"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M872.6,239.5h11.4"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M813.3,262.4h11.4"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M813.3,266.2h11.4"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M813.3,270.1h11.4"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M813.3,273.9h11.4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M793.6,228h11.4"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M793.6,231.8h11.4"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M793.6,235.7h11.4"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M793.6,239.5h11.4"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M789.4,251h19.8"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M793.6,262.4h11.4"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M793.6,266.2h11.4"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M793.6,270.1h11.4"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M793.6,273.9h11.4"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M833.1,262.4h11.4"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M833.1,266.2h11.4"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M833.1,270.1h11.4"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M833.1,273.9h11.4"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M852.8,262.4h11.4"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M852.8,266.2h11.4"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M852.8,270.1h11.4"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M852.8,273.9h11.4"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M872.6,262.4h11.4"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M872.6,266.2h11.4"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M872.6,270.1h11.4"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M872.6,273.9h11.4"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M868.5,251h19.7"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M907.8,216.1h-19.7v69.8h19.7v-69.8h0Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M892.3,228h11.4"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M892.3,231.8h11.4"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M892.3,235.7h11.4"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M892.3,239.5h11.4"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M892.3,262.4h11.4"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M892.3,266.2h11.4"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M892.3,270.1h11.4"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M892.3,273.9h11.4"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M888.1,251h19.7"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M50.1,222.4H12.3v184.7h37.8v-184.7h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M466.1,482.4h-212c-7.8,0-15.5-2.5-21.8-7.2l-71.5-52.9-1.7-1.3c6.2-8.6,17.9-16.9,37.6-18.6,18.6-1.6,28.5-6.9,34.7-14l1.6,1.2,35.3,25.2h198"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M466.1,482.4h-212c-7.8,0-15.5-2.5-21.8-7.2l-73.2-54.3c6.2-8.6,18-17.2,37.7-18.9,18.6-1.6,28.5-6.6,34.6-13.7l1.6,1.2,35.3,25.2h198"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M50.5,184.5l-4.5,116.9,58.3.4c7.8,0,15.1,3.9,21.5,8.4l90.3,64.2c-6.3,7-17.2,12.9-35.8,14.5-19.9,1.7-30.7,9.8-37,18.5h0c0,0-34.4-26.9-34.4-26.9h-58.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M50,184.1v117.3h52.5c7.6,0,15.1,2.4,21.3,6.8l92.3,66.2c-6.2,6.9-17.9,13.3-36.2,14.9-19.6,1.7-30.5,9.7-36.7,18.2l-34.4-27h-58.8v26.7H12.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M152,446.6s-3.6-40.5,44.8-44.5c51.4-4.3,42.7-42.6,42.7-42.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M135.9,433.7s-3.6-40.5,44.7-44.6c51.4-4.4,42.8-42.6,42.8-42.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.1,378.9v-76.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M72.9,314.5v75.5h-9.8v-157.2h9.8v81.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M94,314.5v75.5h-9.8v-157.2h9.8v81.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M50.1,222.3H12.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M459.2,411.7h-127.9v75.1h127.9v-75.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M397.2,496.8c25.8,0,46.7-21,46.7-46.9s-20.9-46.9-46.7-46.9-46.7,21-46.7,46.9,20.9,46.9,46.7,46.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M366.7,419.3l62.3,62.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M366.7,480.5l62.3-62.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M397.1,465.5c8.6,0,15.6-7,15.6-15.6s-7-15.6-15.6-15.6-15.6,7-15.6,15.6,7,15.6,15.6,15.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M365.8,571h11.8v-98.4c-.4,1.3-1.2,2.4-2.3,3.2-1.1.8-2.4,1.2-3.7,1.2-1.3,0-2.6-.4-3.7-1.2s-1.8-1.9-2.1-3.2v98.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M359.6,572.2c0-3.2,1.3-6.3,3.6-8.6,2.3-2.3,5.4-3.6,8.6-3.6s6.3,1.3,8.6,3.6c2.3,2.3,3.6,5.4,3.6,8.6h-24.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M374.5,476.1l28.9-19.8-12.5-13.4-23.6,23.8,7.2,9.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M397.2,458.7c5.1,0,9.2-4.1,9.2-9.2s-4.1-9.2-9.2-9.2-9.2,4.1-9.2,9.2,4.1,9.2,9.2,9.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M371.8,477c3.4,0,6.1-2.7,6.1-6.1s-2.7-6.1-6.1-6.1-6.1,2.7-6.1,6.1,2.7,6.1,6.1,6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M456.6,412h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M456.6,417.3v66.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M456.6,486.2h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M474.2,412h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M474.2,417.3v66.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M474.2,486.2h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M469.4,407.9h-8.1v82.5h8.1v-82.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M461.4,410.2h-4.3v77.8h4.3v-77.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M473.7,410.2h-4.2v77.8h4.2v-77.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320.5,412h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M320.5,417.3v66.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320.5,486.2h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M338,412h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M338,417.3v66.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M338,486.2h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M333.3,407.9h-8.1v82.5h8.1v-82.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M325.1,410.2h-4.3v77.8h4.3v-77.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M337.6,410.2h-4.3v77.8h4.3v-77.8Z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M495.6,199.8h-2.5v22.1h2.5v-22.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M494.4,196.9h8.6c.3,0,.5,0,.8.1.2,0,.5.2.7.4.2.2.3.4.4.7s.1.5.1.8,0,.5-.1.8c0,.2-.2.5-.4.7-.2.2-.4.3-.7.4-.2,0-.5.1-.8.1h-8.6c-.3,0-.5,0-.8-.1-.2,0-.5-.2-.7-.4s-.3-.4-.4-.7-.1-.5-.1-.8,0-.5.1-.8c0-.2.2-.5.4-.7.2-.2.4-.3.7-.4.2,0,.5-.1.8-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M430.3,220.4h60.5c4.1,0,8,1.6,10.9,4.5,2.9,2.9,4.5,6.8,4.5,10.9v4c0,4.1-1.6,8-4.5,10.9-2.9,2.9-6.8,4.5-10.9,4.5h-60.5c-4.1,0-8-1.6-10.9-4.5s-4.5-6.8-4.5-10.9v-4c0-4.1,1.6-8,4.5-10.9,2.9-2.9,6.8-4.5,10.9-4.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M448.6,216.7h-15.3l.7-3.8h13.8l.8,3.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M469.8,217.1h-37.8v3.3h37.8v-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M473.9,220.3c0-.4,0-.7,0-1.1s.2-.7.5-1c.2-.3.5-.6.8-.7s.7-.3,1.1-.4.8,0,1.1,0c.4,0,.7.3,1,.5.3.2.5.5.7.9s.3.7.3,1.1v.7h-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M476.6,214.8h3.5c.3,0,.6,0,.8-.2s.5-.3.7-.5c.2-.2.4-.4.5-.7s.2-.6.2-.8h0v-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M435.6,255.3h-6.4v4h6.4v-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M492,255.3h-6.4v4h6.4v-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M486,211.4h-1.2v8.7h1.2v-8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M485.6,212c2.1,0,3.7-1.7,3.7-3.7s-1.7-3.7-3.7-3.7-3.7,1.7-3.7,3.7,1.7,3.7,3.7,3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M484.5,209l1.2-.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M422.5,206c0-.9.2-1.7.5-2.5.3-.8.8-1.5,1.4-2.1s1.3-1.1,2.1-1.4,1.6-.5,2.5-.5h21.3c.9,0,1.7.2,2.5.5s1.5.8,2.1,1.4,1.1,1.3,1.4,2.1c.3.8.5,1.6.5,2.5s-.2,1.7-.5,2.5c-.3.8-.8,1.5-1.4,2.1s-1.3,1.1-2.1,1.4c-.8.3-1.6.5-2.5.5h-21.3c-1.7,0-3.4-.7-4.6-1.9-1.2-1.2-1.9-2.9-1.9-4.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M432,209.7h19.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M432.8,207.2h20.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M432.8,204.8h20.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M432,202.2h19.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M424,197.5h2.7c.9,0,1.7.4,2.4,1,.6.6,1,1.5,1,2.4v10.3c0,.9-.4,1.7-1,2.4s-1.5,1-2.4,1h-2.7c-.9,0-1.7-.4-2.4-1-.6-.6-1-1.5-1-2.4v-10.3c0-.9.4-1.7,1-2.4s1.5-1,2.4-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M450.5,180.6h17.8c.2,0,.4,0,.6.1s.3.2.5.3.2.3.3.5c0,.2.1.4.1.6s0,.4-.1.6-.2.3-.3.5-.3.2-.5.3c-.2,0-.4.1-.6.1h-17.8v-3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M466.3,197.9h-12.4l-.9-11.1h14.1l-.9,11.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M453.9,180.1h12.4l.9,6.3h-14.1l.9-6.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M449.1,178.1c.3,0,.5,0,.8.1.2,0,.5.2.7.4.2.2.3.4.4.7s.1.5.1.8v4.6c0,.3,0,.5-.1.8,0,.2-.2.5-.4.7-.2.2-.4.3-.7.4-.2,0-.5.1-.8.1s-.5,0-.8-.1c-.2,0-.5-.2-.7-.4-.2-.2-.3-.4-.4-.7s-.1-.5-.1-.8v-4.6c0-.5.2-1.1.6-1.4s.9-.6,1.4-.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M469.1,217.1h-18.1l.9-19.7h16.3l.9,19.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M469.7,182.1h4.7c.3,0,.6,0,.8.2s.5.3.7.5.4.4.5.7c.1.3.2.6.2.8v36"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M518.2,140.4h-23.7l1.2-5.8h21.4l1.2,5.8h0Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M487.9,113.6h33c2.7,0,5.3,1.1,7.2,3,1.9,1.9,3,4.5,3,7.2s-1.1,5.3-3,7.2c-1.9,1.9-4.5,3-7.2,3h-33c-2.7,0-5.3-1.1-7.2-3-1.9-1.9-3-4.5-3-7.2s.2-2.7.8-3.9,1.2-2.4,2.2-3.3c.9-.9,2.1-1.7,3.3-2.2,1.2-.5,2.6-.8,3.9-.8h0Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M492.4,129.6h30.8"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M493.7,125.7h31.4"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M493.7,121.8h31.4"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M492.4,118h30.8"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M480.1,110.6h4.3c.7,0,1.4.1,2,.4.6.3,1.2.6,1.7,1.1.5.5.9,1.1,1.1,1.7s.4,1.3.4,2v16c0,.7-.1,1.4-.4,2s-.6,1.2-1.1,1.7c-.5.5-1.1.9-1.7,1.1s-1.3.4-2,.4h-4.3c-.7,0-1.4-.1-2-.4-.6-.3-1.2-.6-1.7-1.1s-.9-1.1-1.1-1.7-.4-1.3-.4-2v-16c0-.7.1-1.4.4-2s.6-1.2,1.1-1.7c.5-.5,1.1-.9,1.7-1.1s1.3-.4,2-.4Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M401.4,117.2h15.6c.6,0,1.1.2,1.5.6s.6.9.6,1.5h0v2.2c0,.6-.2,1.1-.6,1.5s-.9.6-1.5.6h-5.1c-.3,0-.6,0-.8.1s-.5.3-.7.5-.4.4-.5.7c-.1.3-.2.5-.1.8h0v1.7c0,.6.2,1.1.6,1.5s.9.6,1.5.6h5.1c.6,0,1.1.2,1.5.6s.6.9.6,1.5h0v2.2c0,.6-.2,1.1-.6,1.5s-.9.6-1.5.6h-15.2"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M414.3,142.4c8.7,0,15.8-7.1,15.8-15.8s-7.1-15.8-15.8-15.8-15.8,7.1-15.8,15.8,7.1,15.8,15.8,15.8Z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st16",
    x: 518.6,
    y: 335.4,
    width: 37.4,
    height: 17.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M518.6,324.8h37.4v9.8c0,4.8-3.9,8.7-8.7,8.7h-20c-4.8,0-8.7-3.9-8.7-8.7v-9.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M537.3,291.2c-12.2,0-22.1,9.9-22.1,22.1s9.9,22.1,22.1,22.1,22.1-9.9,22.1-22.1-9.9-22.1-22.1-22.1h0ZM537.3,331.2c-9.8,0-17.9-8-17.9-17.9s8-17.9,17.9-17.9,17.9,8,17.9,17.9-8,17.9-17.9,17.9h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st16",
    cx: 537.3,
    cy: 323.6,
    r: 17.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M794.3,461.7v-18h-195.4v18h195.4Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M739.4,553.7v-201.8h-96.2v201.8h96.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M729.3,359.6v-3.6h-76v3.6h76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M729.3,368.2v-5.5h-76v5.5h76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M729.3,378.9v-7.5h-76v7.5h76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M729.3,391.4v-9.4h-76v9.4h76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M729.3,405.9v-11.3h-76v11.3h76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M729.3,422.3v-13.2h-76v13.2h76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M729.3,440.7v-15.1h-76v15.1h76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M729.3,461v-17.1h-76v17.1h76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M729.3,549v-3.6h-76v3.6h76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M729.3,542.3v-5.5h-76v5.5h76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M729.3,533.6v-7.4h-76v7.4h76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M729.3,522.9v-9.4h-76v9.4h76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M729.3,510.4v-11.3h-76v11.3h76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M729.3,496v-13.2h-76v13.2h76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M729.3,479.5v-15.1h-76v15.1h76Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M587.5,553.7v-201.8h-102v201.8h102Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M485.6,545.5v-189.4h-11.4v189.4h11.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M598.9,545.5v-189.4h-11.4v189.4h11.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M613.2,435.3v5.5h15.3v-5.5h-15.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M613.2,464.8v5.5h15.3v-5.5h-15.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M760.4,435.3v5.5h15.3v-5.5h-15.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M760.4,464.8v5.5h15.3v-5.5h-15.3Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st16",
    x: 523.1,
    y: 312.8,
    width: 28.5,
    height: 202.8,
    rx: 14.1,
    ry: 14.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M551.6,342.3c0-15.1-28.4-15.2-28.5,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M551.6,377.5c.1-13.6-28.3-13.7-28.5,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M551.6,412.7c0-3.3-28.5-3.3-28.5,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M523.1,483.3c0,9.9,28.5,9.9,28.5,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st20",
    x1: 551.6,
    y1: 453.2,
    x2: 523.1,
    y2: 453.2
  })), /*#__PURE__*/React.createElement("rect", {
    className: "st16",
    x: 794.3,
    y: 415.7,
    width: 34.7,
    height: 87.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "847.5 470.1 829.1 475.4 829.1 421.1 847.5 425.2 847.5 470.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M791,425.4h-5.5v15.3h5.5v-15.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M791,464.8h-5.5v15.3h5.5v-15.3Z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M591.9,203.3h1.4c1.4,0,2.7.5,3.6,1.5,1,1,1.5,2.3,1.5,3.6v42c0,.7-.3,1.3-.7,1.7-.5.5-1.1.7-1.7.7h-6.6c-.7,0-1.3-.3-1.7-.7-.5-.5-.7-1.1-.7-1.7v-42c0-.7,0-1.3.3-2,.2-.6.6-1.2,1.1-1.7s1-.9,1.6-1.1,1.3-.4,2-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M623,206.3c.9,0,1.7.2,2.5.5s1.5.8,2.1,1.4,1.1,1.3,1.4,2.1c.3.8.5,1.6.5,2.5v12.7c0,.9-.2,1.7-.5,2.5s-.8,1.5-1.4,2.1-1.3,1.1-2.1,1.4c-.8.3-1.6.5-2.5.5s-1.7-.2-2.5-.5c-.8-.3-1.5-.8-2.1-1.4s-1.1-1.3-1.4-2.1-.5-1.6-.5-2.5v-12.6c0-1.7.7-3.4,1.9-4.7s2.9-2,4.6-2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M619.3,216.8v10.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M621.7,217.4v10.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M624.3,217.4v10.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M626.8,216.8v10.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M640.4,206.3c.9,0,1.7.2,2.5.5s1.5.8,2.1,1.4,1.1,1.3,1.4,2.1c.3.8.5,1.6.5,2.5v12.7c0,.9-.2,1.7-.5,2.5s-.8,1.5-1.4,2.1-1.3,1.1-2.1,1.4c-.8.3-1.6.5-2.5.5s-1.7-.2-2.5-.5c-.8-.3-1.5-.8-2.1-1.4s-1.1-1.3-1.4-2.1c-.3-.8-.5-1.6-.5-2.5v-12.6c0-1.7.7-3.4,1.9-4.7s2.9-2,4.6-2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M636.7,216.8v10.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M639.1,217.4v10.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M641.6,217.4v10.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M644.2,216.8v10.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M692.9,227.2h-93.4v28h93.4v-28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M611.4,189.5h-11.9v20.2h11.9v-20.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M599.5,202.4l-6.9,46.6h6.9v-46.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M592.6,194.9c.6,0,1.1.2,1.5.6s.6.9.6,1.5v4.2c0,.6-.2,1.1-.6,1.5s-.9.6-1.5.6c-.6,0-1.1-.2-1.5-.6s-.6-.9-.6-1.5v-4.2c0-.3,0-.6.1-.8,0-.3.3-.5.5-.7.2-.2.4-.4.7-.5.3,0,.5-.1.8-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M605.4,232.1v18.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M670.6,218.5h-1.2v8.7h1.2v-8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M670.2,219.2c2.1,0,3.7-1.7,3.7-3.7s-1.7-3.7-3.7-3.7-3.7,1.7-3.7,3.7,1.7,3.7,3.7,3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M669.1,216.2l1.2-.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M608.1,209.9c0,.7-.2,1.4-.6,2-.4.6-1.1.9-1.8,1s-1.4,0-2-.5c-.6-.4-1-1-1.1-1.7v-.8h5.5c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M605.4,213v5.8c0,1.3.5,2.6,1.5,3.6s2.2,1.5,3.6,1.5h0c1.2,0,2.3-.4,3.2-1.2l2.7-2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M661.7,214.7h-2.5v6.5h2.5v-6.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M658,211.7h2.5c.3,0,.5,0,.8.1s.5.2.7.4c.2.2.3.4.4.7,0,.2.1.5.1.8s0,.5-.1.8-.2.5-.4.7c-.2.2-.4.3-.7.4s-.5.1-.8.1h-2.5c-.3,0-.5,0-.8-.1-.2,0-.5-.2-.7-.4-.2-.2-.3-.4-.4-.7,0-.2-.1-.5-.1-.8s0-.5.1-.8.2-.5.4-.7.4-.3.7-.4c.2,0,.5-.1.8-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M688.6,222.5h-6.8v4.5h6.8v-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M685.2,224.1c3.1,0,5.7-2.5,5.7-5.7s-2.5-5.7-5.7-5.7-5.7,2.5-5.7,5.7,2.5,5.7,5.7,5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M605.8,255.3h-6.4v4h6.4v-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M692.9,255.3h-6.4v4h6.4v-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M620.2,246.8c2.9,0,5.3-2.4,5.3-5.3s-2.4-5.3-5.3-5.3-5.3,2.4-5.3,5.3,2.4,5.3,5.3,5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M639.7,246.8c2.9,0,5.3-2.4,5.3-5.3s-2.4-5.3-5.3-5.3-5.3,2.4-5.3,5.3,2.4,5.3,5.3,5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M659,246.8c2.9,0,5.3-2.4,5.3-5.3s-2.4-5.3-5.3-5.3-5.3,2.4-5.3,5.3,2.4,5.3,5.3,5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M678.4,246.8c2.9,0,5.3-2.4,5.3-5.3s-2.4-5.3-5.3-5.3-5.3,2.4-5.3,5.3,2.4,5.3,5.3,5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M655.1,213.8c-1.1,0-2.2.4-3,1.2s-1.2,1.9-1.2,3h0v8.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M676.8,222.3h-22.4v4.9h22.4v-4.9Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalfunctionsPeltonHorizontal);
export default __webpack_public_path__ + "static/media/malfunctions_pelton-horizontal.e43da49fe4800b50ae4622c850d24d87.svg";
export { ForwardRef as ReactComponent };